import { useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "store/vino/subscriptionProductsSlice";
import ProductListItem from "./ProductListItem";

const Products = () => {
	const dispatch = useDispatch();
	const list = useSelector(({ vino }) => vino.subscriptionProducts.products);

	useEffect(() => {
		dispatch(getProducts());
	}, []);

	return (
		<div className="l list-view">
			<div className="flex flex-col flex-auto shrink-0 w-full collection-product-wrapper">
				<div className="grid gap-x-8 gap-y-4 grid-cols-3 product-wrapper-grid">
					{list.map((variant, index) => (
						<ProductListItem key={index} variant={variant} />
					))}
				</div>
			</div>
		</div>
	);
};

export default Products;
